import * as React from "react";
import type { SVGProps } from "react";
const SvgAddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="add_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M938.667 512c0 235.648-191.019 426.667-426.667 426.667S85.333 747.648 85.333 512 276.352 85.333 512 85.333 938.667 276.352 938.667 512zM512 853.333a341.333 341.333 0 1 0 0-682.666 341.333 341.333 0 0 0 0 682.666zm0-554.666a42.667 42.667 0 0 1 42.667 42.666v128h128a42.667 42.667 0 1 1 0 85.334h-128v128a42.667 42.667 0 1 1-85.334 0v-128h-128a42.667 42.667 0 1 1 0-85.334h128v-128A42.667 42.667 0 0 1 512 298.667z"
    />
  </svg>
);
export default SvgAddIcon;
